module.exports = __webpack_public_path__ + "static/img/templatenone.4187315d.png";